import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ExtensionPage } from './ExtensionPage';
// ---------------------------------------------------------------------------
// Simple path-based router — SWA rewrites all paths to index.html, so we
// inspect window.location.pathname to pick the right page component.
// ---------------------------------------------------------------------------
function Router() {
    const [path, setPath] = React.useState(window.location.pathname);
    React.useEffect(() => {
        const onPop = () => setPath(window.location.pathname);
        window.addEventListener('popstate', onPop);
        return () => window.removeEventListener('popstate', onPop);
    }, []);
    const extMatch = path.match(/^\/extensions\/([\w-]+)$/);
    if (extMatch) {
        return React.createElement(ExtensionPage, { extensionId: extMatch[1] });
    }
    return React.createElement(App, null);
}
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element #root not found in index.html');
}
createRoot(container).render(React.createElement(Router, null));
